// extracted by mini-css-extract-plugin
export default {"pill":"FilterPill_pill__v1VzK","pillActive":"FilterPill_pillActive__KBsBl","dot":"FilterPill_dot__SdgVs"};